<template>
  <div class="selfservice-content-area hideOnLogout">
    <PromoModal>
      <template v-for="slot in possibleChildSlotsFor('PromoModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PromoModal>
    <BewModal>
      <template v-for="slot in possibleChildSlotsFor('BewModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BewModal>
    <NotificationListWrapper
      :promo-id-list=promoIdList
      :extra-data="extraData"
      :contract-state="contractState"
      :current-customer-contract="currentCustomerContract"
    >
      <template v-for="slot in possibleChildSlotsFor('Notification')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </NotificationListWrapper>
    <div class="app-selfservice-dashboard-wrapper">
      <slot name="txtBefore"></slot>
      <div class="grid-wrapper" :class="{'twoBoxGrid': contractState.contractTerminated}">
        <ConsumptionProgress
          :loaded.sync="consumptionLoaded"
          @loaded="checkAndDisableLoader"
        >
          <template v-for="slot in possibleChildSlotsFor('ConsumptionProgress')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ConsumptionProgress>
        <kwk-banner :contract-state="contractState">
          <template v-for="slot in possibleChildSlotsFor('KwkBannerNotification')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </kwk-banner>
        <CurrentBill
          :loaded.sync="currentBillLoaded"
          @loaded="checkAndDisableLoader"
          :show-connection-fee="false"
          :show-tariff-fee="false"
          :show-discount-fee="false"
          custom-class-name="dashboard"
        >
          <template v-for="slot in possibleChildSlotsFor('CurrentBill')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </CurrentBill>
      </div>
      <slot name="txtAfter"></slot>

      <TariffOptionsDashboardWrapper :in-overview="true">
        <template v-for="slot in possibleChildSlotsFor('TariffOptionsOverview')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </TariffOptionsDashboardWrapper>
    </div>
  </div>
</template>

<script>
import ConsumptionProgress from '@/components/process/generic/Consumption/ConsumptionProgress.vue'
import CurrentBill from '@/components/process/generic/Bill/CurrentBill.vue'
import customerContractState from '@/mixins/customerContractState'
import TariffOptionsDashboardWrapper from '@/components/process/wrapper/TariffOptionsDashboardWrapper.vue'
import { mapGetters, mapMutations } from 'vuex'
import extraData from '@/mixins/extraData'
import NotificationListWrapper
from '@/components/process/wrapper/SelfService/NotificationList/NotificationListWrapper.vue'
import PromoModal from '@/components/modal/PromoModal.vue'
import BewModal from '@/components/modal/BewModal.vue'
import trackingHandler from '@/mixins/trackingHandler'
import KwkBanner from '../../generic/Login/Notifications/KWKBanner.vue'

export default {
  name: 'SelfServiceDashboardWrapper',
  data () {
    return {
      selectedOptions: [],
      consumptionLoaded: false,
      currentBillLoaded: false,
      activeTariffoptionId: ''
    }
  },
  props: {
    promoIdList: {
      type: [String, Number],
      default: '0'
    }
  },
  components: {
    KwkBanner,
    BewModal,
    PromoModal,
    NotificationListWrapper,
    ConsumptionProgress,
    CurrentBill,
    TariffOptionsDashboardWrapper
  },
  mixins: [
    customerContractState(),
    extraData(),
    trackingHandler
  ],
  mounted () {
    this.startLoader()

    if (this.fallBackDashboardError) {
      this.errorToast(this.fallBackDashboardErrorText)
      this.resetFallbackDashboardError()
    }

    this.trackingData()
  },
  methods: {
    ...mapMutations('kwk', [
      'resetFallbackDashboardError'
    ]),
    checkAndDisableLoader () {
      if (this.consumptionLoaded && this.currentBillLoaded) {
        this.stopLoader()
      }
    },
    trackingData () {
      const data = {
        page_levels: [
          'mein-simon',
          'uebersicht'
        ],
        login_status: 'not logged in',
        page_type: 'content',
        platform_type: 'browser view',
        flag_suppress_medallia: this.getActiveModal === 'bew' || this.getActiveModal === 'promo' ? 'true' : 'false'
      }
      this.trackData('pageview', data)
    }
  },
  computed: {
    ...mapGetters('kwk', [
      'fallBackDashboardError',
      'fallBackDashboardErrorText'
    ]),
    ...mapGetters('modals', [
      'getActiveModal',
      'getAggregatedConsents'
    ])
  }
}
</script>
